/* eslint-disable no-unused-vars */
import { axios } from './index'
const resource = '/v1/stay'
const resource_top = '/v1/top'
const resource_cms = '/v1/cms'
import CONST_DATA from '@/mixins/const/constData'

export default {
  /**
   * ログイン処理
   */
  getNews(params) {
    return axios.get(`${resource}/news`, params)
  },
  getNewsId(id, params = {}) {
    return axios.get(`${resource}/news/${id}`, params)
  },

  getNewsMenu() {
    return axios.get(`${resource}/news/menu`)
  },
  /**
   * redisに保存（session更新処理）
   */
  postSession(params) {
    const data = {
      data: {
        sessionKey: 'dummy'
      }
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  /**
   * 初回ログイン完了
   */
  putComplete(params) {
    const data = {}
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  getHeaderFooter() {
    return axios.get(`${resource}/header_footer?bsCode=${CONST_DATA.BO_CODE.BS}`)
  },
  getBlockContents(params) {
    return axios.get(
      `${resource}/block_contents?locationCode=${params.locationCode}`
    )
  }
}
